import { render } from "./index.vue?vue&type=template&id=7522de78"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnkabiu/Development/Projects/Liden/Front-End/VueJs/mobi_games/mobi_games/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__